import React, { useState } from 'react';
import onlyPaws from '../assets/ads/onlypaws.webp';
import ruffLauren from '../assets/ads/ruff-lauren.webp';
import pawPal from '../assets/ads/pawpal.webp';

/**
 * A house advert in a reserved space (lmsbe backlog item 52).
 *
 * No ad network is wired up. Each space shows one of the owner's own parody adverts and a
 * tap opens the page that sells sponsorship of a game or league, so the space advertises the
 * one thing this site has to sell. Nothing here loads from anywhere else or sets a cookie,
 * which is why the privacy page does not change for it; an ad network would.
 *
 * The parodies copy real companies' styling closely and the owner chose to run them knowing
 * that (see the backlog item). Every advert is therefore labelled as an advert and captioned
 * as a parody, and swapping the artwork is a change to the list below and nothing else.
 * There are no betting-firm parodies, deliberately: the owner had the three there were taken
 * out on 28 Oct 2026. Do not add one back.
 *
 * The reserved height still matters and is still the point of the box: anything that changes
 * size after the page has drawn shifts everything below it, and on the Current Round tab a
 * shift means a mis-tap - which is not a bounce, it is picking the wrong team and burning it
 * for the rest of the season. Deliberately NOT placed above the fixtures for the same reason.
 */
const ADVERTS = [
  { brand: 'OnlyPaws', src: onlyPaws },
  { brand: 'Ruff Lauren', src: ruffLauren },
  { brand: 'PawPal', src: pawPal },
];

export default function AdSlot({ height = 90, onOpen, style = {} }) {
  // Chosen once per space: a brand that changed on every render would flicker each time the
  // round refreshed around it.
  // Which joke to show is not a secret, so a predictable generator is fine here.
  // eslint-disable-next-line sonarjs/pseudo-random
  const [advert] = useState(() => ADVERTS[Math.floor(Math.random() * ADVERTS.length)]);
  const imageHeight = Math.max(height - 40, 40);

  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label={`Advert: ${advert.brand}. Find out about sponsoring a game or league`}
      style={{
        width: '100%',
        minHeight: height,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        margin: '12px 0',
        padding: '6px 10px',
        borderRadius: 12,
        border: '1px solid rgba(168, 85, 247, 0.25)',
        background: 'rgba(255, 255, 255, 0.04)',
        cursor: 'pointer',
        ...style,
      }}
    >
      <span style={{ alignSelf: 'flex-start', fontSize: 10, fontWeight: 700, letterSpacing: '0.5px',
        textTransform: 'uppercase', color: 'rgba(255, 255, 255, 0.55)' }}>
        Advert
      </span>
      <img
        src={advert.src}
        alt={advert.brand}
        style={{ maxHeight: imageHeight, maxWidth: '100%', objectFit: 'contain', borderRadius: 6 }}
      />
      <span style={{ fontSize: 10, color: 'rgba(255, 255, 255, 0.45)' }}>
        Parody advert - not a real company
      </span>
    </button>
  );
}
